import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087744.svg";
import mailIcon from "@assets/images/mail-fill.svg";
import phoneIcon from "@assets/images/phone-fill.svg";
import buildingIcon from "@assets/images/building-2-fill.svg";
import { HeroSection, EmergencyCTASection } from "../../components";
import { SustainabilityPage } from "@features/general";

export function Sustainability() {
  return (
    <SustainabilityPage
      hero={
        <HeroSection
          title="Cleaner Energy. Safer Operations. Sustainable Tomorrow."
          description="At GASIS, sustainability is embedded in everything we do — from smart metering and emissions reduction to safety excellence and community engagement."
          heroImage={heroImage}
        />
      }
      footer={
        <>
          <EmergencyCTASection
            title="Committed to a Sustainable Future"
            subtitle={
              <>
                Learn more about our sustainability initiatives
                <br />
                or get in touch with our team.
              </>
            }
          >
            <div className="rounded-3xl bg-white flex flex-col items-start p-6 gap-4">
              <div className="flex items-center gap-2.5">
                <img src={mailIcon} alt="" className="w-4 h-4" />
                <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
                  sustainability@gasis.ae
                </span>
              </div>
              <div className="flex items-center gap-2.5">
                <img src={phoneIcon} alt="" className="w-4 h-4" />
                <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
                  800-GASIS (42747)
                </span>
              </div>
              <div className="flex items-center gap-2.5">
                <img src={buildingIcon} alt="" className="w-4 h-4" />
                <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
                  Sunday – Thursday (8 AM – 6 PM)
                </span>
              </div>
            </div>
          </EmergencyCTASection>
          <Footer />
        </>
      }
    />
  );
}

export default Sustainability;
